'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _next = require('@alifd/next');

var _service = require('./service');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var statusQuery = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(options) {
    var params, onAbort, onProgress, onSuccess, onError, _options$maxTimes, maxTimes, _options$interval, interval, times, _abort, progressCall;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            params = options.params, onAbort = options.onAbort, onProgress = options.onProgress, onSuccess = options.onSuccess, onError = options.onError, _options$maxTimes = options.maxTimes, maxTimes = _options$maxTimes === undefined ? 180 : _options$maxTimes, _options$interval = options.interval, interval = _options$interval === undefined ? 2e3 : _options$interval;
            times = 0;
            _abort = false;

            progressCall = function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref3, response, status;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _service._form_table_queryExportResponse_)(params);

                      case 2:
                        _ref3 = _context.sent;
                        response = _ref3.data;
                        status = response.status;

                        if (!_abort) {
                          _context.next = 8;
                          break;
                        }

                        onAbort && onAbort();
                        return _context.abrupt('return');

                      case 8:
                        if (!(status === 'PROCESS_FINISHED')) {
                          _context.next = 12;
                          break;
                        }

                        onProgress && onProgress(response);
                        setTimeout(function () {
                          onSuccess && onSuccess(response);
                        }, 1000);
                        return _context.abrupt('return');

                      case 12:
                        if (!(times >= maxTimes)) {
                          _context.next = 15;
                          break;
                        }

                        onError && onError(new Error('等待超时'));
                        return _context.abrupt('return');

                      case 15:
                        if (status === 'PROCESSING') {
                          onProgress && onProgress(response);
                        }
                        times++;
                        return _context.abrupt('return', new Promise(function (resolve) {
                          setTimeout(resolve, interval);
                        }).then(progressCall));

                      case 18:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined);
              }));

              return function progressCall() {
                return _ref2.apply(this, arguments);
              };
            }();

            progressCall();
            return _context2.abrupt('return', {
              abort: function abort() {
                return _abort = true;
              }
            });

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function statusQuery(_x) {
    return _ref.apply(this, arguments);
  };
}();

var ExportButton = (_temp = _class = function (_Component) {
  _inherits(ExportButton, _Component);

  function ExportButton() {
    var _this2 = this;

    _classCallCheck(this, ExportButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.onProgress = function (response) {
      var percentage = response.percentage;

      _this.setState({ percentage: percentage });
    };

    _this.onError = function (e) {
      // TODO
      _this.setState({ loading: false });
    };

    _this.onSuccess = function (response) {
      var percentage = response.percentage,
          fileUrl = response.fileUrl;

      _this.setState({ loading: false, percentage: percentage, url: fileUrl });
    };

    _this.handleOpen = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this$props, scene, params, getData, _ref5, success, errorMsg, tableData, _ref6, _success, _errorMsg;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$props = _this.props, scene = _this$props.scene, params = _this$props.params, getData = _this$props.getData;
              // 点击打开弹窗，并触发导出数据

              _this.setState({ loading: true, percentage: 0 });
              _context3.prev = 2;

              if (!(scene === 'BigTable')) {
                _context3.next = 14;
                break;
              }

              _context3.next = 6;
              return (0, _service._form_table_big_export_)(params);

            case 6:
              _ref5 = _context3.sent;
              success = _ref5.success;
              errorMsg = _ref5.errorMsg;

              if (success) {
                _context3.next = 12;
                break;
              }

              _next.Message.error(errorMsg);
              return _context3.abrupt('return');

            case 12:
              _context3.next = 23;
              break;

            case 14:
              tableData = getData && getData();
              _context3.next = 17;
              return (0, _service._form_table_normal_export_)(_extends({}, params, { tableData: tableData }));

            case 17:
              _ref6 = _context3.sent;
              _success = _ref6.success;
              _errorMsg = _ref6.errorMsg;

              if (_success) {
                _context3.next = 23;
                break;
              }

              _next.Message.error(_errorMsg);
              return _context3.abrupt('return');

            case 23:
              _context3.next = 29;
              break;

            case 25:
              _context3.prev = 25;
              _context3.t0 = _context3['catch'](2);

              _context3.t0 && _next.Message.error(_context3.t0.message);
              return _context3.abrupt('return');

            case 29:

              _this.setState({ visible: true });
              // 导出数据后轮训查询
              _context3.next = 32;
              return statusQuery({
                params: params,
                onProgress: _this.onProgress,
                onSuccess: _this.onSuccess,
                onError: _this.onError
              });

            case 32:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[2, 25]]);
    }));

    _this.handleClose = function () {
      _this.setState({ visible: false });
    };

    _this.renderContent = function () {
      var _this$state = _this.state,
          loading = _this$state.loading,
          percentage = _this$state.percentage,
          url = _this$state.url;

      if (loading) {
        return _react2.default.createElement(
          'div',
          { style: { justifyContent: 'center', alignItems: 'center' } },
          _react2.default.createElement(
            'span',
            null,
            '\u6B63\u5728\u4E3A\u60A8\u51C6\u5907\u6587\u4EF6\u2026\u2026'
          ),
          _react2.default.createElement(_next.Progress, { percent: percentage })
        );
      } else {
        return _react2.default.createElement(
          'a',
          { href: url, target: '_blank', download: true },
          '\u70B9\u51FB\u4E0B\u8F7D'
        );
      }
    };

    _this.state = {
      loading: false,
      visible: false,
      percentage: 0,
      url: ''
    };
    return _this;
  }

  ExportButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        type = _props.type,
        label = _props.label,
        disabled = _props.disabled;
    var _state = this.state,
        visible = _state.visible,
        loading = _state.loading;

    return _react2.default.createElement(
      _react.Fragment,
      null,
      !visible && _react2.default.createElement(
        _next.Button,
        { className: className, text: true, type: type, onClick: this.handleOpen, disabled: disabled },
        label
      ),
      _react2.default.createElement(
        _next.Dialog,
        {
          title: '\u5BFC\u51FA\u6570\u636E',
          visible: visible,
          style: { width: '360px' },
          footer: _react2.default.createElement(
            _next.Button,
            { type: 'primary', onClick: this.handleClose },
            loading ? '取消导出' : '关闭'
          ),
          closeable: false
        },
        this.renderContent()
      )
    );
  };

  return ExportButton;
}(_react.Component), _class.defaultProps = {
  label: '导出数据',
  disabled: false
}, _temp);
exports.default = ExportButton;
module.exports = exports['default'];